export const CLIENT_ID_PREFIX = '848255-';
